
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Header } from 'components/header'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Jugend-Event YouNews geht in die fünfte Runde' lead='Mitmachen statt zuschauen: Die Schweizer Jugendmedienwoche YouNews findet 2022 statt.' mdxType="Header" />
    <p>{`In der Woche vom 2. bis zum 8. Mai 2022 können Jugendliche erneut hinter
die Kulissen der wichtigsten Schweizer Medienhäuser schauen und gemeinsam mit
Profis Artikel schreiben, Videos drehen, Radio-Shows moderieren oder auf
Socialmedia-Plattformen Storys posten. Das Ziel der 2018 lancierten Schweizer
Medienveranstaltung für Jugendliche: Journalismus verstehen, Journalismus
erleben, Journalismus mitgestalten. Die in der Medienwoche gestalteten Artikel,
Radio- und Videobeiträge werden im jeweiligen Gastmedium publiziert.
Schulklassen oder Gruppen von Jugendlichen zwischen 13 und 20 Jahren und ihre
Lehrpersonen können sich ab sofort unter dem jeweiligen
Projektbeschrieb für eine Teilnahme bewerben.`}</p>
    <p>{`Für weitere Einblicke, folgt unserem Insta-Channel
`}<a parentName="p" {...{
        "href": "https://www.instagram.com/explore/tags/younews2022/"
      }}>{`#younews2022`}</a>{`.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;